import { FC, useEffect, useState } from 'react'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { getCommonData } from '../../store/commonSlice'
import Input, { IInput, TInputEvent } from '../form/Input'

const ShipperSelect: FC<IInput> = ({ defaultValue, value, handle, ...props }) => {
  // --
  // -- get common data from Store
  const common = useTypedSelector(getCommonData())
  console.log('value', value)

  // --
  // -- Origin Name
  const resetValue = () => handle && handle({ target: { value: defaultValue } } as TInputEvent)

  // --
  // -- Carrier Names
  const [carrierNames, setCarrierNames] = useState<string[]>()

  useEffect(() => {
    if (common?.shippingCarriers?.length) {
      const names = common.shippingCarriers.map(({ name }) => name)
      if (value && !names.includes(String(value))) names.push(String(value))
      setCarrierNames(() => names.sort())
    }
  }, [common?.shippingCarriers?.length, value])

  return (
    <Input
      className='z-50'
      options={
        !carrierNames
          ? [{ value: value || '' }]
          : carrierNames.map((name) => ({
              title: name,
              value: name,
            }))
      }
      {...props}
      value={value || ''}
      handle={handle}
      description={
        defaultValue && value !== defaultValue ? (
          <>
            Original carrier:{' '}
            <span
              className=' text-primary hover:text-primary_hover underline'
              role='button'
              tabIndex={-1}
              onClick={resetValue}
            >
              {defaultValue}
            </span>
          </>
        ) : (
          ''
        )
      }
    />
  )
}

export default ShipperSelect
